module.exports = __webpack_public_path__ + "img/icon-woodpacking-en.b9dbf496.svg";